<template>
  <div class="app-container">
    <list ref="list"  @reload="reload">
      <!-- <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
        <el-button size="mini" type="success" plain @click="onExport">导出</el-button>
      </template> -->
      <!-- <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.Status == 2" @click="detailsById(row.DocId)">查看</el-button>
            <el-button type="text" v-if="row.Status != 2" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" v-if="row.Status != 2" @click="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status != 2" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template> -->
    </list>
    <!-- <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" /> -->
  </div>
</template>
<script>
import curdMixins from '@/mixins/curd'
import list from '@/components/stock/repository/docquery/list'
// import editDialog from '@/components/stock/repository/preturn/editDialog'
// import detailsDialog from '@/components/stock/repository/preturn/detailsDialog'
export default {
  name: 'comment',
  mixins: [curdMixins],
  components: {
    list
    // editDialog,
    // detailsDialog
  },
  data() {
    return {
      api: require('@/api/stock/stBook').default,
      Details: [],
      isLoading: false
    }
  },
  methods: {
    reload() {
      this.$refs.list.reload()
      this.Details = []
    },
    onChange(row) {
      this.Details = []
      this.isLoading = true
      this.api.info(row.DocId).then(res => {
        this.isLoading = false
        if (res.Data) this.Details = res.Data.Goods
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 5 || index === 7) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100
              } else {
                return Math.floor(prev * 100) / 100
              }
            }, 0)
            sums[index] = sums[index]
          }
          return
        }
      })
      return sums
    },
    check(row) {
      sessionStorage.setItem('check', '1')
      this.$refs.detailsDialog.openEditById(row.DocId)
    },
    detailsById(id) {
      this.$refs.detailsDialog.openDetailsById(id)
    },
    delRows(id) {
      this.$confirm('确认删除数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.delete(id).then(res => {
            if (res.Code == 0) {
              this.$message.success('删除成功')
              this.$refs.list.reload()
            } else {
              this.$message.error(res.Msg)
            }
          })
        })
        .catch(() => {})
    },
    onExport() {
      this.$confirm('是否导出数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.list.onExport()
        })
        .catch(() => {})
    }
  }
}
</script>
